var clientApp = (function () {
    var clientApp = angular.module('clientApp', ['ngAnimate', 'ngResource', 'dialogService', 'angularSpinner', 'ngDialog', 'ui.bootstrap.tabs','angularjsToast']);

    clientApp.config(function ($interpolateProvider) {
        $interpolateProvider.startSymbol('[[').endSymbol(']]');
    });

    clientApp.filter('sex', function () {
        return function (sex) {
            return sex == 2 ? 'Ж' : 'М';
        };
    });

    clientApp.filter('dateFromNow', function () {
        return function (date) {
            return moment(date, moment.ISO_8601).fromNow();
        };
    });

    clientApp.factory('Contact', ['$resource',
        function ($resource) {
            return $resource(
                '/api/v1/clients/:clientId/contacts',
                {'clientId': '@id'},
                {
                    update: {method: 'PUT'}
                }
            );
        }]
    );

    clientApp.factory('Client', [
            '$resource',
            function ($resource) {
                return $resource(
                    '/api/v1/clients/:clientId',
                    { 'clientId': '@id' },
                    {
                        get: { method: 'GET' }
                    }
                );
            }
        ]
    );

    clientApp.factory('RestaurantGroup', ['$resource',
        function ($resource) {
            return $resource(
                '/api/restaurantgroups/:groupId',
                {'groupId': '@id'},
                {
                    update: {method: 'PATCH'}
                }
            );
        }]
    );

    clientApp.factory('ContactPosition', ['$resource',
        function ($resource) {
            return $resource('/api/contactpositions/:Id.json', {'Id': '@id'});
        }]
    );

    /* TODO see task https://restoclub.myjetbrains.com/youtrack/issue/CRM-635
        clientApp.factory('ProContact', [
            '$resource',
            function ($resource) {
                return $resource('/api/pro-user/:client/check-email/:email', {'client': '@client','email': '@email'}, {
                });
            }
            ]
        );
    */

    clientApp.factory('MailingType', ['$resource',
        function ($resource) {
            return $resource('/api/mailingtypes/:Id.json', {'Id': '@id'});
        }]
    );

    clientApp.factory('Task', ['$resource',
        function ($resource) {
            return $resource('/api/simple/task/:Id', {'Id': '@id'});
        }]
    );

    clientApp.factory('Service', ['$resource',
        function ($resource) {
            return $resource('/api/simple/service/:Id', {'Id': '@id'});
        }]
    );
    return clientApp;
})();
